import { PageLoadingState } from '@/components/common/page-states';
import { usePageChrome } from '@/hooks/page-chrome-store';

/**
 * What a route shows while its page's chunk loads: a spinner where the page will be. In the
 * shell it sits in the page's column; outside it (sign-in, onboarding) it fills the screen on
 * the background the session restore showed. A page loading has nothing to do with the
 * session, so neither says so (#936).
 */
export function PageChunkLoading() {
  if (usePageChrome() !== null) return <PageLoadingState variant="compact" />;
  return (
    <div className="flex min-h-svh bg-secondary">
      <PageLoadingState variant="compact" />
    </div>
  );
}
